import {
  GET,
  DELETE,
  POST,
  PUT
} from '../http'
import * as Types from './types'

export default class JobsGateway {
  getJobTypes () {
    return GET(Types.GET_JOB_TYPES)
  }

  getJobs () {
    return GET(Types.GET_JOBS)
  }

  getJob (params = {}) {
    return GET(Types.GET_JOB, params)
  }

  updateJob (query = {}) {
    return PUT(Types.UPDATE_JOB, query)
  }

  addJob (query = {}) {
    return POST(Types.ADD_JOB, query)
  }

  deleteJob (params = {}) {
    return DELETE(Types.DELETE_JOB, params)
  }
}



// WEBPACK FOOTER //
// ./src/api/jobs/JobsGateway.js